<template>
  <div>
    <div class="container">
      <div class="infoContain">
        <div>
          <div class="flex jus-stt" style="margin-left: 10px">
            <h3>기본 정보</h3>
          </div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickNextBtn)"
            >
              <div class="flex mobileFlex wd100">
                <div class="profileImgBox wd50">
                  <div class="profileImgInputBox preview-image">
                    <input
                      class="upload-name"
                      disabled="disabled"
                      :style="`background-image:url(${imageUrl});`"
                    />
                    <label for="input-file"></label>
                    <input
                      type="file"
                      id="input-file"
                      class="upload-hidden"
                      accept="image/*"
                      @change="setFileImage"
                    />
                  </div>
                </div>
                <div class="flex flex-col wd50">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="아이디"
                    rules="required|id"
                    v-slot="{ errors }"
                  >
                    <label>아이디<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.id" maxlength="20" />
                    <input
                      type="button"
                      value="중복확인"
                      @click="onClickConfirmId"
                      :disabled="errors[0] != null"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="비밀번호"
                    rules="required|pw"
                    vid="비밀번호"
                    v-slot="{ errors }"
                  >
                    <label
                      >비밀번호<span class="labelItem">*</span> (특수문자 포함,
                      8자리 이상)</label
                    >
                    <div class="flex flexAlignS border">
                      <input
                        type="password"
                        v-model="signupInfo.password"
                        maxlength="16"
                        autocomplete="new-password"
                      />
                      <div>
                        <span class="fs20 fw500 cl-green">O</span>
                        <span class="fs20 fw500 cl-red ml-4">X</span>
                      </div>
                    </div>

                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="비밀번호 재확인"
                    rules="required|confirmed:@비밀번호"
                    vid="비밀번호 재확인"
                    v-slot="{ errors }"
                  >
                    <label
                      >비밀번호 확인<span class="labelItem">*</span> (한번 더
                      입력해주세요.)</label
                    >
                    <div class="flex flexAlignS border">
                      <input
                        type="password"
                        v-model="confirmedPassword"
                        maxlength="16"
                      />
                      <div>
                        <span class="fs20 fw500 cl-green">O</span>
                        <span class="fs20 fw500 cl-red ml-4">X</span>
                      </div>
                    </div>
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="이름"
                    rules="required|name"
                    v-slot="{ errors }"
                  >
                    <label>이름<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.name" maxlength="16" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="휴대폰번호"
                  rules="required|mobileTel"
                  v-slot="{ errors, valid }"
                >
                  <label>휴대폰 번호<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.phoneNumber"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                    maxlength="11"
                  />
                  <input
                    type="button"
                    value="인증번호 받기"
                    @click="onClickRequestVerifyNumber(valid)"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="inputBox infoBox">
                  <label>성별<span class="labelItem">*</span></label>
                  <div class="bspRadio">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="btn-radios-1"
                        v-model="signupInfo.gender"
                        :options="genderOptions"
                        :aria-describedby="ariaDescribedby"
                        name="radios-btn-default"
                        buttons
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="인증번호"
                  rules="verifyNum"
                  v-slot="{ errors, valid }"
                >
                  <label>인증번호 6자리 입력</label>
                  <input
                    v-model="verifyNumber"
                    maxlength="6"
                    @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                    :placeholder="counterPlaceHolder"
                  />
                  <input
                    type="button"
                    value="확인"
                    @click="onClickConfirmVerifyNumber(valid)"
                    :disabled="counter == 0"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                  <vac
                    ref="verifyNumberCounter"
                    :autoStart="false"
                    :end-time="new Date().getTime() + 180000"
                  >
                    <template v-slot:process="{ timeObj }">
                      {{ onProcesssVerifyNumberCounter(timeObj) }}
                    </template>
                    <template v-slot:finish>
                      {{ onFinishVerifyNumberCounter() }}
                    </template>
                  </vac>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="생년월일"
                  rules="required|dateNoHyphen"
                  v-slot="{ errors }"
                >
                  <label>생년월일<span class="labelItem">*</span></label>
                  <input
                    v-model="signupInfo.birthday"
                    maxlength="10"
                    placeholder="YYYYMMDD"
                  />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider
                  class="inputBox infoBox wd50"
                  name="이메일"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <label>이메일<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.email" maxlength="40" />
                  <span class="notValidationTxt">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  class="inputBox infoBox wd50 flex"
                  rules="required"
                >
                  <label>구분<span class="labelItem">*</span></label>
                  <div class="flex">
                    <div class="checkBoxItem">
                      <input
                        v-model="signupInfo.classification"
                        type="radio"
                        id="one"
                        value="1"
                        class="radioCheckbox"
                      />
                      <label for="one"> 학생 </label>
                    </div>
                    <div class="checkBoxItem ml-5">
                      <input
                        v-model="signupInfo.classification"
                        type="radio"
                        id="two"
                        value="2"
                        class="radioCheckbox"
                      />
                      <label for="two"> 연구원 </label>
                    </div>
                    <div class="checkBoxItem ml-5">
                      <input
                        v-model="signupInfo.classification"
                        type="radio"
                        id="three"
                        value="3"
                        class="radioCheckbox"
                      />
                      <label for="three"> 기업인 </label>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <Address
                :signupInfo="signupInfo"
                :childDataLoaded="childDataLoaded"
                @set-address="setAddress"
              />
              <div class="btnBox flex topPd">
                <button
                  type="button"
                  class="btnFont redborderBtn"
                  @click="onClickBeforeBtn"
                >
                  이 전
                </button>
                <button type="submit" class="btnFont redBtn">다 음</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters, mapMutations, mapActions } from "vuex";
import Address from "@/components/join/Address";
import * as eventUtil from "@/utils/eventUtil";
import * as addressFind from "@/utils/addressFind";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Address,
  },
  data() {
    return {
      sortUser: "",
      eventUtil: eventUtil,
      signupInfo: {
        id: "",
        password: "",
        avatar: "",
        name: "",
        email: "",
        phoneNumber: "",
        birthday: "",
        classification: 0,
        categoryTargetIdx: "",
        city: "",
        gender: "",
      },
      checkedId: "", // 중복검사 완료된 아이디
      checkedPhoneNumber: "", // 인증을 요청한 전화번호
      confirmedPassword: "", // 비밀번호 재확인 값
      isVerified: false, // 전화번호 인증 여부
      verifyNumber: "", // 인증번호
      counter: 0, // 인증번호 유효 시간 카운터
      counterPlaceHolder: "", // 인증번호 유효 시간 카운터(출력용)
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      genderOptions: [
        { text: "남", value: "M" },
        { text: "여", value: "F" },
      ],
      selected: "man",
      childDataLoaded: false,
      imageUrl: require("@/assets/images/user/camera-icon.png"),
      file: null,
      categoryMember: [
        { key: "0", value: "학생" },
        {
          key: "1",
          value: "연구원",
        },
        {
          key: "2",
          value: "기업인",
        },
      ],
      /* categoryMemberSelected: "", */
    };
  },
  computed: {
    ...mapGetters("join", ["getType", "getCurrentTab", "getSignupForm"]),
  },
  mounted() {
    this.childDataLoaded = true;
  },
  watch: {
    getCurrentTab(val, old) {
      if (old == 3) {
        this.signupInfo = this.lodash.cloneDeep(this.getSignupForm);
      }
    },
  },
  methods: {
    ...mapMutations("join", ["setCurrentTab", "setSignupForm"]),
    ...mapActions("auth", ["isAlreadyExistUsername"]),
    ...mapActions("sms", ["requestVerifyNumber", "confirmVerifyNumber"]),
    ...mapActions("file", ["uploadAvatar"]),
    onClickConfirmId() {
      if (!this.signupInfo.id) {
        this.$alert("알림", "아이디를 입력해주세요.");
        return false;
      }

      this.isAlreadyExistUsername(this.signupInfo.id)
        .then((response) => {
          const data = response.data;

          var requestId = data.REQUEST_USERNAME;
          var result = data.RESULT;

          if (result == true) {
            this.checkedId = "";
            this.$alert("알림", "이미 존재하는 아이디 입니다.");
          } else {
            this.checkedId = requestId;
            this.$alert("알림", "사용 가능한 아이디 입니다.");
          }
        })
        .catch(() => {
          this.checkedId = "";
        });
    },
    onClickRequestVerifyNumber(isValidPhoneNumber) {
      if (!isValidPhoneNumber || this.signupInfo.phoneNumber === "") {
        this.$alert("알림", "휴대폰번호를 확인해주세요.");
        return;
      }

      const phoneNumber = this.signupInfo.phoneNumber;
      this.isVerified = false;

      this.requestVerifyNumber({
        phoneNumber: phoneNumber,
        contents: "[경희대학교 AgeTech Platform] 회원가입 전화번호 인증",
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.checkedPhoneNumber = phoneNumber; // 인증번호를 요청한 전화번호 저장
            this.$refs.verifyNumberCounter.startCountdown("restart");
            this.$alert(
              "알림",
              "인증번호를 발송했습니다.(유효시간 3분) <br>" +
                "인증번호가 오지 않으면 <br> 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
                "이미 가입된 번호이거나, 가상전화번호는<br> 인증번호를 받을 수 없습니다."
            );
          } else {
            this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
            this.$refs.verifyNumberCounter.finishCountdown();
            if (
              data.ERROR_CODE == "SUCCESSIVE_REQUEST" ||
              data.ERROR_CODE == "BLOCKED"
            ) {
              this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
            } else {
              this.$alert("알림", "인증번호 요청을 실패했습니다.");
            }
          }
        })
        .catch(() => {
          this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
          this.$refs.verifyNumberCounter.finishCountdown();
          this.$alert("알림", "인증번호 요청을 실패했습니다.");
        });
    },
    onClickConfirmVerifyNumber(isValidVerifyNumber) {
      if (!isValidVerifyNumber || this.verifyNumber === "") {
        return;
      }

      this.confirmVerifyNumber({
        phoneNumber: this.checkedPhoneNumber,
        verifyNum: this.verifyNumber,
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.isVerified = true;
            this.$refs.verifyNumberCounter.finishCountdown();
            this.$alert("알림", "인증되었습니다.");
          } else {
            this.isVerified = false;
            this.$alert("알림", "유효하지 않은 인증번호 입니다.");
          }
        })
        .catch(() => {
          this.isVerified = false;
          this.$alert("알림", "요청 실패");
        });
    },
    onProcesssVerifyNumberCounter(timeObj) {
      this.counter = timeObj.m * 60 + timeObj.s;
      this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`;
    },
    onFinishVerifyNumberCounter() {
      this.counter = 0;
      this.counterPlaceHolder = "";
    },
    onClickSearchAdderss() {
      addressFind.FindAddress(this);
    },
    onClickBeforeBtn() {
      this.signupInfo.id = "";
      this.signupInfo.password = "";
      this.signupInfo.email = "";
      this.signupInfo.phoneNumber = "";
      this.signupInfo.name = "";
      this.signupInfo.birthday = "";
      this.signupInfo.gender = "M";
      this.signupInfo.categoryTargetIdx = "";
      this.signupInfo.city = "";
      this.signupInfo.avatar = "";
      this.checkedId = "";
      this.checkedPhoneNumber = "";
      this.confirmedPassword = "";
      this.isVerified = false;
      this.verifyNumber = "";
      this.counter = 0;
      this.counterPlaceHolder = "";
      this.addr1 = "";
      this.postcode = "";

      this.setSignupForm(this.signupInfo);

      this.setCurrentTab(1);
    },
    async onClickNextBtn() {
      if (!(this.signupInfo.id === this.checkedId)) {
        this.$alert("알림", "아이디 중복확인을 해주세요.");
        return;
      }
      if (!(this.signupInfo.password === this.confirmedPassword)) {
        this.$alert("알림", "비밀번호가 일치하지 않습니다.");
        return;
      }

      // if (!(this.isVerified && this.signupInfo.phoneNumber === this.checkedPhoneNumber)) {
      // 	this.$alert('알림', '전화번호를 인증해주세요.')
      // 	return
      // }

      // Upload image
      if (this.file) {
        const url = await this.uploadAvatar(this.file);
        this.signupInfo.avatar = url;

        const signupInfo = this.signupInfo;

        this.setSignupForm(signupInfo);
        this.setCurrentTab(3);
      } else {
        const signupInfo = this.signupInfo;

        this.setSignupForm(signupInfo);
        this.setCurrentTab(3);
      }
    },
    setAddress(_, __, addressId, addressDetailId) {
      this.signupInfo.categoryTargetIdx = parseInt(addressId);
      this.signupInfo.city = addressDetailId;
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      let check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. <br>(gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)"
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "첨부파일은 10mb이하의 크기만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },
  },
};
</script>

<style scoped lang="scss">
.checkBoxForm ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
.bspRadio {
  padding-left: 0;
  text-align: center;
  & ::v-deep {
    @import "~bootstrap/dist/css/bootstrap.min";

    .btn-group {
      & > .btn:not(:first-child) {
        margin-left: 2rem;
      }
    }
  }
}
</style>

<style scoped>
input:disabled {
  color: #7d7d7d;
}
.profileImgBox {
  padding: 0 1rem;
  /* padding: 40px 0; */
  text-align: center;
}
.profileImgInputBox {
  position: relative;
  width: 100%;
  height: 96%;
}
.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.profileImgInputBox label:active {
  transform: scale(0.97);
}
.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 0;
  margin-left: 0px;
  top: 0;
}
.profileImgInputBox .upload-name {
  border: 0;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
  /* background-image: url('../../../assets/images/user/imgEnroll.png'); */
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}
/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}
@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}
.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}
.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}
.width-100pc {
  width: 100%;
}
.radio-item input {
  border: 1px solid #272727;
  width: 22px;
  height: 22px;
}
.radio-item label {
  white-space: nowrap;
}
</style>
